import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
const HomePage = () => import('../views/HomePage')
const Custom = () => import('../views/Custom')
//*******以下为添加内容*******
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}
// router.js
//适应手机端 开始
const ua = window.navigator.userAgent;
let isMobile = false;
if (ua.indexOf('iPhone') >= 0) isMobile = true;
if (ua.indexOf('Android') >= 0) isMobile = true;
if (ua.indexOf('iPad') >= 0) isMobile = true;

// 如果是移动端，给 .vue 的命名特殊处理，这里多了一级目录 mobile/
const path = isMobile ? 'mobile' : '';
//适应手机端 结束

const router = new VueRouter({
  mode: 'history',
  base: __dirname,
  routes: [{
      path: '/',
      // component: HomePageimport('../views/HomePage')
      component: (resolve) => require([`@/${path}views/HomePage`], resolve),
    },{
      path: '/custom',
      // component: Custom
    component: (resolve) => require([`@/${path}views/Custom`], resolve),
    },{
      path: '/cart',
    component: (resolve) => require([`@/${path}views/Cart`], resolve),
    },
    {
      path: '/checkout',
    component: (resolve) => require([`@/${path}views/checkout/Checkout`], resolve),
    },
    {
      path: '/sucess',
    component: (resolve) => require([`@/${path}views/Sucess`], resolve),
    },
    {
      path: '/account',
    component: (resolve) => require([`@/${path}views/account/Index`], resolve),
    },
    {
      path: '/editAccount',
    component: (resolve) => require([`@/${path}views/account/Edit`], resolve),
    },
    {
      path: '/order',
    component: (resolve) => require([`@/${path}views/order/Index`], resolve),
    },
    // 地址管理
    {
      path: '/address',
    component: (resolve) => require([`@/${path}views/address/Index`], resolve),
    },// 地址管理
    {
      path: '/editAddress',
    component: (resolve) => require([`@/${path}views/address/Edit`], resolve),
    },
    //评论
    // {
    //   path: '/comment',
    // component: (resolve) => require([`@/${path}views/comment/Index`], resolve),
    // },
    {
      //关于我们
      path: '/about-us',
    component: (resolve) => require([`@/${path}views/single/About`], resolve),
    },
    {
      //常见问题
      path: '/faq',
    component: (resolve) => require([`@/${path}views/faq/Index`], resolve),
    },
    {
      //博客
      path: '/blog',
    component: (resolve) => require([`@/${path}views/blog/Index`], resolve),
    }, {
      //博客
      path: '/blog/detail',
    component: (resolve) => require([`@/${path}views/blog/Detail`], resolve),
    }
    // ,{
    //   //商品
    //   path: '/goods',
    // component: (resolve) => require([`@/${path}views/goods/index`], resolve),
    // }
    ,{
      //条件和条款
      path: '/terms-of-service',
    component: (resolve) => require([`@/${path}views/terms/Index`], resolve),
    },{
      //退款退货
      path: '/return-and-refund-policy',
    component: (resolve) => require([`@/${path}views/policy/return`], resolve),
    },{
      //运输政策
      path: '/shipping-policy',
    component: (resolve) => require([`@/${path}views/policy/shipping`], resolve),
    },{
      //隐私协议
      path: '/privacy-policy',
    component: (resolve) => require([`@/${path}views/policy/privacy`], resolve),
    },{
      //付款政策
      path: '/payment-policy',
      component: (resolve) => require([`@/${path}views/policy/payment`], resolve),
    },{
      //知识产权
      path: '/intellectual-property-rights',
      component: (resolve) => require([`@/${path}views/policy/intellectual`], resolve),
    },{
      //担保
      path: '/warranty',
      component: (resolve) => require([`@/${path}views/policy/warranty`], resolve),
    },
    {
      //隐私协议
      path: '/measure',
      component: (resolve) => require([`@/${path}views/single/Measure`], resolve),
    },{
      //愿望
      path: '/wishlist',
    component: (resolve) => require([`@/${path}views/Wish`], resolve),
    },{
      //批发条款
      path: '/wholesale',
    component: (resolve) => require([`@/${path}views/single/Wholesale`], resolve),
    },
    {
      //面料管理
      path: '/fabrics',
    component: (resolve) => require([`@/${path}views/fabrics/Index`], resolve),
    }, {
      //订制页
      path: '/customs',
    component: (resolve) => require([`@/${path}views/customs/Index`], resolve),
    },{
      //联系我们
      path: '/contact-us',
    component: (resolve) => require([`@/${path}views/contact/Index`], resolve),
    },{
      //订单追踪
      path: '/track-your-order',
    component: (resolve) => require([`@/${path}views/track/Index`], resolve),
    },{
      //核心技术
      path: '/core-technology',
    component: (resolve) => require([`@/${path}views/single/technology`], resolve),
    },{
      //客户案例
      path: '/client-Cases',
    component: (resolve) => require([`@/${path}views/single/Client`], resolve),
    },{
      path: '/goods',
    component: (resolve) => require([`@/${path}views/conventionGoogs/goods`], resolve),
    },{
      path: '/type-shape',
    component: (resolve) => require([`@/${path}views/customGoods/type-shape`], resolve),
    },{
      path: '/dimensions',
    component: (resolve) => require([`@/${path}views/customGoods/dimensions`], resolve),
    },{
      path: '/fabric-colour',
    component: (resolve) => require([`@/${path}views/customGoods/fabric-colour`], resolve),
    },
    // {
    //   path: '/tying-method',
    // component: (resolve) => require([`@/${path}views/customGoods/tying-method`], resolve),
    // },{
    //   path: '/anti-slip-method',
    // component: (resolve) => require([`@/${path}views/customGoods/anti-slip-method`], resolve),
    // },{
    //   path: '/piped-edges',
    // component: (resolve) => require([`@/${path}views/customGoods/piped-edges`], resolve),
    // },
    {
      path: '/finishing',
    component: (resolve) => require([`@/${path}views/customGoods/finishing`], resolve),
    },{
      path: '/featured',
    component: (resolve) => require([`@/${path}views/customGoods/featured`], resolve),
    },{
      path: '/custom-SFJD-015',
    component: (resolve) => require([`@/${path}views/conventionGoogs/goods1`], resolve),
    },{
      path: '/custom-MS-057',
    component: (resolve) => require([`@/${path}views/conventionGoogs/goods2`], resolve),
    },{
      path: '/custom-cover-SFJD-016',
    component: (resolve) => require([`@/${path}views/conventionGoogs/goods3`], resolve),
    },{
      path: '/custom-S2041-10',
    component: (resolve) => require([`@/${path}views/conventionGoogs/goods4`], resolve),
    },{
      path: '/custom-S2041-4',
    component: (resolve) => require([`@/${path}views/conventionGoogs/goods5`], resolve),
    },{
      path: '/custom-cushion-SFJD-016',
    component: (resolve) => require([`@/${path}views/conventionGoogs/goods6`], resolve),
    }
  ]
});


export default router;

//生成的sitemap.xml
// function getRoutesList(routes, pre) {
//   return routes.reduce((array, route) => {
//     const path = `${pre}${route.path}`;

//     if (route.path !== '*') {
//       array.push(path);
//     }

//     if (route.children) {
//       array.push(...getRoutesList(route.children, `${path}/`));
//     }

//     return array;
//   }, []);
// }


// function getRoutesXML() {
//   const list = getRoutesList(router.options.routes, 'https://rofielty.com')
//     .map(route => `<url><loc>${route}</loc></url>`)
//     .join('\r\n');
//   return `<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:schemaLocation="http://www.sitemaps.org/schemas/sitemap/0.9 http://www.sitemaps.org/schemas/sitemap/0.9/sitemap.xsd">
//     ${list}
//   </urlset>`;
// }

// console.log(getRoutesXML())



// WEBPACK FOOTER //
// ./src/router/index.js